import { GET_RUBRICA } from '@package/actions';

const initialState = {
  error: null,
  hasError: false,
  result: {},
  loading: false,
  loaded: false,
};

export const rubricaReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_RUBRICA}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
      };

    case `${GET_RUBRICA}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        loading: false,
        loaded: true,
      };

    case `${GET_RUBRICA}_FAIL`:
      return {
        ...state,
        error: action.error,
        hasError: true,
        loading: false,
        loaded: true,
      };

    default:
      return state;
  }
};
